import { Content, Root } from '@radix-ui/react-accordion';
import styled, { keyframes } from 'styled-components';

const open = keyframes({
    from: { height: 0 },
    to: { height: 'var(--radix-collapsible-content-height)' }
});

const close = keyframes({
    from: { height: 'var(--radix-collapsible-content-height)' },
    to: { height: 0 }
});

export const StyledRoot = styled(Root)`
    width: 100%;
`;

export const StyledContent = styled(Content)`
    overflow: hidden;
    max-height: fit-content;
    padding-left: 24px;
    padding-bottom: 12px;
    width: 100%;

    &[data-state='open'] {
        animation: ${open} 100ms ease-in-out; // todo: extract to constants file?
    }

    &[data-state='closed'] {
        animation: ${close} 100ms ease-in-out; // todo: extract to constants file?
    }
`;
